// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import { useIsMutating } from '@tanstack/react-query';
import { useAlerts } from '../../../hooks/useAlerts';
import { AlertContainer } from '../../common/Alert';
import '../../../components/common/LoadingSpinner.css';

/**
 * Shows a loading indicator when backend computation is in progress
 */
export const BackendComputationIndicator: React.FC = () => {
  const isMutating = useIsMutating({ mutationKey: ['decision-tree-compute'] });
  const loading = isMutating > 0;
  
  const { alerts, closeAlert } = useAlerts();

  return (
    <>
      <AlertContainer alerts={alerts} onClose={closeAlert} />

      {loading && (
        <div
          style={{
            position: 'fixed',
            bottom: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            borderRadius: '8px',
            background: '#1e40af',
            color: '#fff',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            fontSize: '13px',
            fontWeight: '500',
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            style={{
              animation: 'spin 1s linear infinite',
            }}
          >
            <circle cx="12" cy="12" r="10" opacity="0.25" />
            <path d="M12 2a10 10 0 0 1 10 10" opacity="0.75" />
          </svg>
          <span>Computing results...</span>
          <style>
            {`
              @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}
    </>
  );
};
